import { cloudfrontPath } from '@utils/image'

export const DEFAULT_AROW_ICON = `${cloudfrontPath}/images/prices/prices-arrow-orange.svg`

export const HOVER_AROW_ICON = `${cloudfrontPath}/images/prices/prices-arrow-white.svg`
